import React from 'react';
import { Heading } from '../../../../components';
import { careerIntro, images } from '../../../../constants';
import { FaBriefcase } from 'react-icons/fa';
import './CareerIntro.css';
import { useTranslation } from 'react-i18next';

const CareerIntro = () => {
    
    const { t } = useTranslation();

    return (
        <section className='career-intro'>
            <div className='content'>
                <Heading title={t('career.intro.heading')} subTitle={t('career.intro.sub')} sideHeading={true} />
                <p>{t('career.intro.description')}</p>
                <ul className="career-features">
                    {careerIntro.pointsKeys.map((pointKey, index) => (
                        <li key={index}>
                            <FaBriefcase className="icon" />
                            <span>{t(pointKey)}</span>
                        </li>
                    ))}
                </ul>
            </div>
            <div className='image'>
                <img src={images.about2} alt='Career-Pic' />
            </div>
        </section>
    );
};

export default CareerIntro;